import { forwardRef } from 'react';

import type { TypographyProps } from '@mui/material';
import { Typography as MuiTypography } from '@mui/material';

export const VideaTypography = forwardRef(
  <C extends React.ElementType>(
    props: TypographyProps<C, { component?: C }>,
    ref?: any,
  ) => {
    const { children } = props;
    return (
      <MuiTypography {...props} ref={ref}>
        {children}
      </MuiTypography>
    );
  },
);
